import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-modal-add-trade-agreement',
  templateUrl: './modal-add-trade-agreement.component.html',
  styleUrls: ['./modal-add-trade-agreement.component.scss']
})
export class ModalAddTradeAgreementComponent implements OnInit {

  actualRow: any;
  showTable: boolean = true;
  providerTypes: any;
  filterTerm: string = '';

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    { variable: 'internal_code', displayedName: 'Código Interno'},
    { variable: 'business_unit_name', displayedName: 'Nombre Unidad de Negocio'},
    { variable: 'business_unit_code', displayedName: 'Unidad de Negocio'},
    { variable: 'product_line', displayedName: 'Línea de producto'},
    { variable: 'product_name', displayedName: 'Nombre Producto'},
    { variable: 'product_line_code', displayedName: 'Código línea'},
    { variable: 'total_code', displayedName: 'Código total'},
    // { variable: 'provider_name', displayedName: 'Proveedor'},
    { variable: 'base_price', displayedName: 'Precio base'},
    { variable: 'type_pay_traducted', displayedName: 'Tipo de precio'},
    // { variable: 'currency', displayedName: 'divisa'},
    // { variable: 'product_cost', displayedName: 'Costo Proveedor'},
  ];
  dataSource: any = [];
  dataHelpper: any = [];

  modalForm = this.fb.group({
    base_price: new FormControl(''),
    trial_price: new FormControl(''),
    trial_end_cap: new FormControl(''),
    trial_start: new FormControl(''),
    badge: new FormControl('Bs'),
    price_type: new FormControl('percentage'),
    time: new FormControl(''),
    quantity: new FormControl('')
  });

  constructor(
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalAddTradeAgreementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    if( data.exclude_ids != undefined){
      this.getProducts();
    }
    if(this.data.showTable != undefined){
      this.showTable = this.data.showTable;
      this.modalForm.get('base_price').setValue(this.data.row.product_price);
      this.modalForm.get('trial_price').setValue(this.data.row.trial_price);
      this.modalForm.get('trial_end_cap').setValue(this.data.row.trial_end_cap);
      this.modalForm.get('trial_start').setValue(this.data.row.trial_start);
      this.modalForm.get('time').setValue(this.data.row.time);
      this.modalForm.get('quantity').setValue(this.data.row.quantity);

      // var typesHelpper: any = [];
      // this.uService.providerTypes.forEach(type => {
      //   if(!(['credit', 'quantity' ].indexOf(type.value) > -1)){
      //     typesHelpper.push(type);
      //   }
      // });
      // this.providerTypes = typesHelpper;
      this.modalForm.get('price_type').disable();
    }else{

    }
    this.providerTypes = this.uService.providerTypes;
  }

  setFocus(id: any) {
    var input  = document.getElementById(id);
    if(input !== null){
      input.focus();
    }
  }

  getProducts(){
    var concat_ids: string = '';
    this.data.exclude_ids.forEach((element: any, index: number) => {
      if( index < this.data.exclude_ids.length - 1){
        concat_ids = concat_ids + `exclude_ids[]=${element}&`
      }else{
        concat_ids = concat_ids + `exclude_ids[]=${element}`
      }
      index ++;
    });


    this.mService.get_request(`product/list?${concat_ids}`)
    .subscribe((resp: any)=>{
      if(resp.status){
        var dataResp = resp.items;

        var arrayToReturn: any = [];
        if(this.data.dataSource.length != 0){
          dataResp.forEach(element => {
            var equalFlag: boolean = false;
            this.data.dataSource.forEach(elementData => {
              if(elementData.id == element.id){
                if(elementData.status != 'inactive'){
                  equalFlag = true;
                  return;
                }
              }
            });
            if(equalFlag == false){
              arrayToReturn.push(element);
            }
          });
        }else{
          arrayToReturn = resp.items;
        }

        //translated
        var arrayTranslated: any = [];
        arrayToReturn.forEach(element => {
          var type_pay_traducted: string = '';
            switch (element.type_pay) {
              case 'percentage':
                type_pay_traducted = 'Porcentaje'
              break;
              case 'flat_fee':
                type_pay_traducted = 'Tarifa plana'
              break;
            }
            arrayTranslated.push({...element, type_pay_traducted});
          });

          this.dataSource = arrayTranslated;
          this.dataHelpper = [...arrayTranslated];
      }else{
        if(resp.message){
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      }
    })
  }

  setValuestoForm(row: any): void {
      this.actualRow = row;

      if (row.trial_period == 0) {
        this.modalForm.get('trial_price').disable();
        this.modalForm.get('trial_end_cap').disable();
        this.modalForm.get('trial_start').disable();
      }else{
        this.modalForm.get('trial_price').enable();
        this.modalForm.get('trial_end_cap').enable();
        this.modalForm.get('trial_start').enable();
      }
  }

  filterName(event: any){
    this.dataSource = [...this.dataHelpper];
    if(event.value === 'credit'){
      var rowsFiltered = [];
      this.dataSource.forEach(row => {
        if(['device-rent', 'device-sale'].indexOf(row.code.toLowerCase()) > -1){
          rowsFiltered.push(row)
        }
      });
      if(rowsFiltered.length === 0){
        this.toast.error('Producto "Dispositivo" no encontrado', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
      this.dataSource = rowsFiltered;
    }

    if(event.value === 'quantity'){
      var rowsFiltered = [];
      this.dataSource.forEach(row => {
        if(['paper', 'cash-pay'].indexOf(row.code.toLowerCase()) > -1 ){
          rowsFiltered.push(row)
        }
      });
      if(rowsFiltered.length === 0){
        this.toast.error('Producto "Papel" no encontrado', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
      this.dataSource = rowsFiltered;
    }
  }

  addComertialAgreementProduct() {
    var price = this.modalForm.get('base_price').value;
    var trial_price = this.modalForm.get('trial_price').value;
    var trial_end_cap = this.modalForm.get('trial_end_cap').value;
    var trial_start = this.modalForm.get('trial_start').value;
    var price_type = this.modalForm.get('price_type').value;

    if(this.actualRow == undefined){
      this.toast.error('Seleccione un producto para continuar', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    }else{
      if(price.length == 0){
        this.toast.error('El campo precio no puede estar vacío', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        return;
      }
      // if(price == 0){
      //   this.toast.error('El campo precio no puede ser cero', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      //   return;
      // }
      if(price < this.actualRow.base_price){
        this.toast.error('El campo precio no puede ser menor al precio base del producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        return;
      }
      // if(trial_price > this.actualRow.base_price){
      //   this.toast.error('El campo precio prueba no puede ser mayor al precio base del producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      //   return;
      // }
      if(price_type == ''){
        this.toast.error('El campo tipo de precio debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        return;
      }
      // if(trial_price != '' && trial_end_cap == ''){
      //   this.toast.error('El campo periodo de prueba debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      //   return;
      // }
      // if(trial_price == '' && trial_end_cap != ''){
      //   this.toast.error('El campo precio prueba debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      //   return;
      // }

      var rowModified = {
        ...this.actualRow,
        product_price: this.modalForm.get('base_price').value,
        trial_price: this.modalForm.get('trial_price').value,
        trial_end_cap: this.modalForm.get('trial_end_cap').value,
        trial_start: this.modalForm.get('trial_start').value,
        price_type: this.modalForm.get('price_type').value,
      }

      if(this.modalForm.get('price_type').value === 'credit'){
        rowModified.time = this.modalForm.get('time').value;
      }

      if(this.modalForm.get('price_type').value === 'quantity'){
        rowModified.quantity = this.modalForm.get('quantity').value;
      }

      this.dialogRef.close(rowModified);
    }
  }

  editComertialAgreementProduct() {
    var price = this.modalForm.get('base_price').value;
    var trial_price = this.modalForm.get('trial_price').value;
    var trial_end_cap = this.modalForm.get('trial_end_cap').value;
    var trial_start = this.modalForm.get('trial_start').value;
    var price_type = this.modalForm.get('price_type').value;

    if(price.length == 0){
      this.toast.error('El campo precio no puede estar vacío', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      return;
    }
    // if(price == 0){
    //   this.toast.error('El campo precio no puede ser cero', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //   return;
    // }
    // if(price < this.actualRow.base_price){
    //   this.toast.error('El campo precio no puede ser menor al precio base del producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //   return;
    // }
    // if(trial_price > this.actualRow.base_price){
    //   this.toast.error('El campo precio prueba no puede ser mayor al precio base del producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //   return;
    // }
    if(price_type == ''){
      this.toast.error('El campo tipo de precio debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      return;
    }
    // if(trial_price != '' && trial_end_cap == ''){
    //   this.toast.error('El campo periodo de prueba debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //   return;
    // }
    // if(trial_price == '' && trial_end_cap != ''){
    //   this.toast.error('El campo precio prueba debe tener un valor', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //   return;
    // }

    var body: any = {
      commercial_agreement_id: this.data.row.commercial_agreement_id,
      product_id: this.data.row.id,
      id_cap: this.data.row.id_cap,
      product_price: this.modalForm.get('base_price').value,
      trial_price: this.modalForm.get('trial_price').value,
      trial_end_cap: this.modalForm.get('trial_end_cap').value,
      trial_start: this.modalForm.get('trial_start').value,
      price_type: this.modalForm.get('price_type').value,
    }

    if(this.modalForm.get('price_type').value === 'credit'){
      body.time = this.modalForm.get('time').value;
    }

    if(this.modalForm.get('price_type').value === 'quantity'){
      body.quantity = this.modalForm.get('quantity').value;
    }

    this.mService.post_request('commercial-agreements-product/update', body)
    .subscribe((resp: any)=>{
      if (resp.status) {
        this.toast.success(resp.message, 'Éxito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.dialogRef.close( 'reload' );
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
      }
    })
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

